export default {
  id: null,
  regulationAutoID: null,
  typeConclusionID: null,
  reasonFrustration: null,
  lossTypeID: null,
  hasNonconformityBudget: null,
  nonconformityBudgetReason: null,
  nonconformityBudgetDescription: null,
  rescheduleInspection: null,
  emailAdm: null,
  actionDate: null,
  urlBudgetSystem: null
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/analyze/sinisteranalyze-model.js